import { Injectable, inject } from '@angular/core';

import { FsApi, RequestConfig } from '@firestitch/api';

import { Observable } from 'rxjs';

import { Foundation } from '@app/common/interfaces';


@Injectable({
  providedIn: 'root',
})
export class FoundationData<T = any> {
  private _api = inject(FsApi);


  public create(data: Foundation = { id: null }): Foundation {
    return data;
  }

  public get(id: number, query: any = {}, config: RequestConfig = {}): Observable<T> {
    return this._api.get(
      `foundations/${id}`,
      query,
      {
        key: 'foundation',
        ...config,
      },
    );
  }

  public gets(query: any = {}, config: RequestConfig = {}): Observable<T> {
    return this._api.request(
      'GET',
      'foundations',
      query,
      {
        key: 'foundations',
        ...config,
      },
    );
  }

  public put(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.put(
      `foundations/${data.id}`,
      data,
      {
        key: 'foundation',
        ...config,
      },
    );
  }

  public post(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.post(
      'foundations',
      data,
      {
        key: 'foundation',
        ...config,
      },
    );
  }

  public query(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.post(
      `foundations/${data.id}/query`,
      data,
      {
        key: 'foundation',
        ...config,
      },
    );
  }

  public queryBulk(data: any = [], config: RequestConfig = {}): Observable<T> {
    return this._api.post(
      `foundations/query/bulk`,
      data,
      {
        key: 'foundation',
        ...config,
      },
    );
  }

  public delete(data: any, config: RequestConfig = {}): Observable<T> {
    return this._api.delete(
      `foundations/${data.id}`,
      data,
      {
        key: 'foundation',
        ...config,
      },
    );
  }

  public save(data: any): Observable<T> {
    return (data.id)
      ? this.put(data)
      : this.post(data);
  }

}
